<template>
  <div class="block pt-1">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      no-class="helpicon hover:stroke-2 w-5 h-5 transition-all stroke-current"
      class="helpicon w-5 h-5 transition-all"
      alt="help"
      @click="showTooltip($event)"
      @mouseover="showTooltip($event)"
      @mouseout="hideTooltip()"
    >
      <!--
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12 16V12" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 8H12.01" stroke-linecap="round" stroke-linejoin="round" />
    -->
      <circle cx="12" cy="12" r="11" class="fill-Primary-200" />
      <g transform="matrix(1,0,0,1,12.23,17.532)">
        <path
          d="M-2.8,0L2.8,0L2.8,-1.6L1.04,-1.6L1.04,-8.48L-2.576,-8.48L-2.576,-6.88L-0.816,-6.88L-0.816,-1.6L-2.8,-1.6L-2.8,0ZM0,-9.68C0.235,-9.68 0.459,-9.728 0.672,-9.824C0.885,-9.92 1.04,-10.077 1.136,-10.296C1.232,-10.515 1.28,-10.736 1.28,-10.96C1.28,-11.195 1.232,-11.419 1.136,-11.632C1.04,-11.845 0.885,-12 0.672,-12.096C0.459,-12.192 0.235,-12.24 0,-12.24C-0.224,-12.24 -0.445,-12.192 -0.664,-12.096C-0.883,-12 -1.04,-11.845 -1.136,-11.632C-1.232,-11.419 -1.28,-11.195 -1.28,-10.96C-1.28,-10.736 -1.232,-10.515 -1.136,-10.296C-1.04,-10.077 -0.883,-9.92 -0.664,-9.824C-0.445,-9.728 -0.224,-9.68 0,-9.68Z"
           class="fill-white"
        />
      </g>
    </svg>

    <ClientOnly  >
      <template  v-if="tooltip.tooltipPosition.value.owner===tooltipId">        
        <Teleport to="#teleport-header" >

        </Teleport>
        <Teleport to="#teleport-content" >
          <slot></slot>
        </Teleport>
      </template>
    </ClientOnly>

  </div>
</template>

<script>
export default {
  name: 'HelpTooltip',
  setup(){
    const tooltip = useTooltip();
    return { tooltip }

  },
  data() {
    return {
      showt: false,
      elementLeft: 0,
      elementTop: 0,
      tooltipId: "help-tooltip",
    }
  },

  methods: {
    showTooltip(event) {
      this.tooltip.show(event.pageX, event.pageY,this.tooltipId);
    },
    hideTooltip() {
      this.tooltip.hide();
    }
  }
}
</script>

<style lang="css" scoped>
.tooltip-content-inner {
  padding: 1rem;
  text-align: left;
}

.tooltip-custom {
  width: 340px;
  height: auto;
  position: fixed;
  top: 50vh;
  left: 10vw;
  z-index: 40;
  background: #fff;
  color: rgba(0, 0, 0, 0.7);
  padding: 0.35rem 0.75rem;
  font-size: 0.95rem;
  font-weight: 300;
  box-shadow: 0 1px 2px 1px rgb(0 1 0 / 20%);
  border-radius: 6px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  max-width: 400px;
}

.helpicon {
  display: block;
  cursor: pointer;
  margin-left: 0.5rem;
}
</style>
